import React, { useState } from "react";
import { toast } from "react-toastify";
import Search from "../../../components/form/Search";
import Button from "../../../components/form/Button";
import Table from "../../../components/elements/table/Table";
import { setTitle } from "../../../helpers/MetaTag";
import { handleFilterChange } from "../../../helpers";
import DeleteModal from "../../../components/common/DeleteModal";

import useFetch from "../../../hooks/useFetch";
import { useDebounce } from "../../../hooks/useDebounce";
import LimitSelect from "../../../components/elements/LimitSelect";

import useMutation from "../../../hooks/useMutation";
import Switch from "../../../components/form/Switch";
import Badge from "../../../components/elements/Badge";

import {
  planDelete,
  planList,
  planOrdering,
  planStatusChange,
} from "../../../services/plansService";
import ManagePlanModal from "./modals/ManagePlanModal";

const Plans = () => {
  setTitle("MemoryDoodle Admin | Plans");
  const [selectedItems, setSelectedItems] = useState([]);
  const [modalOpen, setModalOpen] = useState({ isOpen: false, data: null });
  const [keyword, setKeyword] = useState("");
  const search = useDebounce(keyword, 300);
  const [deleteModal, setDeleteModal] = useState({
    isOpen: false,
    data: null,
  });
  const [filters, setFilters] = useState({
    limit: 10,
    page: 1,
    sortQuery: "ordering",
  });

  const { data, error, isLoading, updateData, isFetching, refetch } = useFetch({
    dependencies: ["plans", filters, search],
    fetchFunction: async () => {
      const {
        status = [],
        highLightTag = [],
        isFeatured = [],
        ...restFilters
      } = filters || {};
      const res = await planList({
        ...restFilters,
        ...Object.fromEntries(status.map((val, i) => [`status[${i}]`, val])),
        ...Object.fromEntries(
          highLightTag.map((val, i) => [`highLightTag[${i}]`, val])
        ),
        ...Object.fromEntries(
          isFeatured.map((val, i) => [`isFeatured[${i}]`, val])
        ),

        ...(search && { keyword: search }),
      });
      return res?.docs;
    },
  });

  const { mutate: statusChangeHandler, isPending: statusChangeInPending } =
    useMutation({
      mutationFn: async ({ id, status, isFeatured, highLightTag }) => {
        const payload = {
          ids: id,
          ...(typeof status !== "undefined" && { status }),
          ...(typeof isFeatured !== "undefined" && { isFeatured }),
          ...(typeof highLightTag !== "undefined" && { highLightTag }),
        };

        const res = await planStatusChange(payload);
        return { res, payload };
      },
      onSuccess: ({ res, payload }) => {
        if (res?.status !== 200) {
          updateData((pre) => {
            pre.data = (pre?.data || []).map((elm) => {
              if (elm?._id === payload?.ids) {
                return {
                  ...elm,
                  ...(payload.status && {
                    status: payload.status === "active" ? "inactive" : "active",
                  }),
                  ...(payload.isFeatured && {
                    isFeatured: payload.isFeatured === true ? false : true,
                  }),
                  ...(payload.highLightTag && {
                    highLightTag: payload.highLightTag === 1 ? 2 : 1,
                  }),
                };
              }
              return elm;
            });
            return { ...pre };
          });
        }
      },
      onError: (error) => {
        console.error(" Plans Status change error:", error);
      },
    });

  const tableHeadData = [
    {
      _id: 2,
      name: "Name",
      align: "left",
      // isSort: true,
      // isFilter: false,
      // isFilterSearch: false,
      // onSort: (val) => {
      //   if (val === "DESC") {
      //     // setSort("-description");
      //   } else {
      //     // setSort("description");
      //   }
      // },
    },
    // {
    //   _id: 3,
    //   name: "Description",
    //   align: "left",
    //   // isSort: false,
    //   // isFilter: false,
    //   // isFilterSearch: false,
    // },
    // {
    //   _id: "contentCount",
    //   name: "Content Count",
    //   align: "left",
    // },
    {
      _id: "price",
      name: "Price",
      align: "left",
    },
    // {
    //   _id: "interval",
    //   name: "Interval",
    //   align: "left",
    // },
    {
      _id: "highLightTag",
      name: "Most Popular",
      align: "left",
      isFilter: true,
      isFilterSearch: false,
      onFilter: (val) => {
        if (val?.length > 0) {
          setFilters((pre) => ({
            ...pre,
            highLightTag: val?.map((item) => item?.value),
            page: 1,
          }));
        } else {
          setFilters((pre) => {
            delete pre?.highLightTag;
            return { ...pre };
          });
        }
      },
      filterData: [
        { name: "Most Popular", value: 1, type: "checkbox" },
        { name: "Unpopular", value: 2, type: "checkbox" },
      ],
    },
    // {
    //   _id: "featured",
    //   name: "Featured",
    //   align: "left",
    //   isFilter: true,
    //   isFilterSearch: false,
    //   onFilter: (val) => {
    //     if (val?.length > 0) {
    //       setFilters((pre) => ({
    //         ...pre,
    //         featured: val?.map((item) => item?.value),
    //         page: 1,
    //       }));
    //     } else {
    //       setFilters((pre) => {
    //         delete pre?.featured;
    //         return { ...pre };
    //       });
    //     }
    //   },
    //   filterData: [
    //     { name: "Featured", value: 1, type: "checkbox" },
    //     { name: "Unfeatured", value: 2, type: "checkbox" },
    //   ],
    // },
    {
      _id: 4,
      name: "Status",
      align: "left",
      isFilter: true,
      isFilterSearch: false,
      onFilter: (val) => {
        if (val?.length > 0) {
          setFilters((pre) => ({
            ...pre,
            status: val?.map((item) => item?.value),
            page: 1,
          }));
        } else {
          setFilters((pre) => {
            delete pre?.status;
            return { ...pre };
          });
        }
      },
      filterData: [
        { name: "Active", value: "active", type: "checkbox" },
        { name: "Inactive", value: "inactive", type: "checkbox" },
      ],
    },
    {
      _id: 5,
      name: "Action",
      align: "left",
    },
  ];
  // console.log(data?.data, "data");
  // Table Body Data =====================>
  const tableData = data?.data?.map((item) => {
    return {
      _id: item?._id,
      rowData: [
        {
          _id: 2,
          type: "text",
          align: "left",
          cellClass: "!min-w-[100px]",
          data:
            (
              <div
                dangerouslySetInnerHTML={{ __html: item?.name || "-" }}
              ></div>
            ) || "-",
        },
        // {
        //   _id: 3,
        //   type: "text",
        //   align: "left",
        //   cellClass: "!min-w-[100px]",
        //   data:
        //     (
        //       <div
        //         dangerouslySetInnerHTML={{ __html: item?.description || "-" }}
        //       ></div>
        //     ) || "-",
        // },
        // {
        //   _id: "contentCount",
        //   type: "text",
        //   align: "left",
        //   cellClass: "!min-w-[100px]",
        //   data:
        //     (
        //       <div
        //         dangerouslySetInnerHTML={{ __html: item?.contentCount || "-" }}
        //       ></div>
        //     ) || "-",
        // },
        {
          _id: "price",
          type: "text",
          align: "left",
          cellClass: "!min-w-[100px]",
          data:
            (
              <div
                dangerouslySetInnerHTML={{
                  __html: item?.planPricingData?.price || "-",
                }}
              ></div>
            ) || "-",
        },
        // {
        //   _id: "interval",
        //   type: "text",
        //   align: "left",
        //   cellClass: "!min-w-[100px]",
        //   data:
        //     (
        //       <div
        //         dangerouslySetInnerHTML={{ __html: item?.interval || "-" }}
        //       ></div>
        //     ) || "-",
        // },
        {
          _id: "highLightTag",
          type: "text",
          align: "left",
          cellClass: "!min-w-[100px]",
          data: (
            <div className="flex gap-2 items-center">
              {/* <Switch
                className={
                  "!w-10 !h-5 before:!w-4 before:!h-4 peer-checked:before:!left-[22px]"
                }
                checked={item?.highLightTag === 1}
                onChange={() => {
                  updateData((pre) => {
                    pre.data = (pre?.data || []).map((elm) =>
                      elm?._id === item?._id
                        ? {
                            ...elm,
                            highLightTag: elm?.highLightTag === 1 ? 2 : 1,
                          }
                        : elm
                    );
                    return { ...pre };
                  });
                  statusChangeHandler({
                    id: item?._id,
                    highLightTag: item?.highLightTag === 1 ? 2 : 1,
                  });
                }}
              /> */}

              <Switch
                className="!w-10 !h-5 before:!w-4 before:!h-4 peer-checked:before:!left-[22px]"
                checked={item?.highLightTag === 1}
                onChange={() => {
                  if (item?.highLightTag === 1) {
                    // If already most popular, just unmark
                    updateData((pre) => {
                      pre.data = (pre?.data || []).map((elm) =>
                        elm?._id === item?._id
                          ? { ...elm, highLightTag: 2 }
                          : elm
                      );
                      return { ...pre };
                    });

                    statusChangeHandler({
                      id: item?._id,
                      highLightTag: 2,
                    });
                  } else {
                    // Set current as most popular, others as not
                    updateData((pre) => {
                      pre.data = (pre?.data || []).map((elm) => ({
                        ...elm,
                        highLightTag: elm._id === item._id ? 1 : 2,
                      }));
                      return { ...pre };
                    });

                    statusChangeHandler({
                      id: item?._id,
                      highLightTag: 1,
                    });
                  }
                }}
              />

              <Badge
                type={item?.highLightTag === 1 ? "success" : "danger"}
                label={item?.highLightTag === 1 ? "Most Popular" : "Unpopular"}
              />
            </div>
          ),
        },
        // {
        //   _id: "featured",
        //   type: "text",
        //   align: "left",
        //   cellClass: "!min-w-[100px]",
        //   data: (
        //     <div className="flex gap-2 items-center">
        //       <Switch
        //         className={
        //           "!w-10 !h-5 before:!w-4 before:!h-4 peer-checked:before:!left-[22px]"
        //         }
        //         checked={item?.featured === 1}
        //         onChange={() => {
        //           updateData((pre) => {
        //             pre.data = (pre?.data || []).map((elm) =>
        //               elm?._id === item?._id
        //                 ? { ...elm, featured: elm?.featured === 1 ? 2 : 1 }
        //                 : elm
        //             );
        //             return { ...pre };
        //           });
        //           statusChangeHandler({
        //             id: item?._id,
        //             featured: item?.featured === 1 ? 2 : 1,
        //           });
        //         }}
        //       />
        //       <Badge
        //         type={item?.featured === 1 ? "success" : "danger"}
        //         label={item?.featured === 1 ? "Featured" : "UnFeatured"}
        //       />
        //     </div>
        //   ),
        // },
        {
          _id: 4,
          type: "text",
          align: "left",
          cellClass: "!min-w-[100px]",
          data: (
            <div className="flex gap-2 items-center">
              <Switch
                className={
                  "!w-10 !h-5 before:!w-4 before:!h-4 peer-checked:before:!left-[22px]"
                }
                checked={item?.status === "active"}
                onChange={() => {
                  updateData((pre) => {
                    pre.data = (pre?.data || []).map((elm) =>
                      elm?._id === item?._id
                        ? {
                            ...elm,
                            status:
                              elm?.status === "active" ? "inactive" : "active",
                          }
                        : elm
                    );
                    return { ...pre };
                  });
                  statusChangeHandler({
                    id: item?._id,
                    status: item?.status === "active" ? "inactive" : "active",
                  });
                }}
              />
              <Badge
                type={item?.status === "active" ? "success" : "danger"}
                label={item?.status === "active" ? "Active" : "Inactive"}
              />
            </div>
          ),
        },
        {
          _id: 5,
          type: "action",
          align: "left",
          // cellClass: "w-[5%]",
          actionData: [
            {
              _id: 1,
              name: "Edit",
              icon: "fa-regular fa-pen-to-square",
              onClick: () => {
                setModalOpen({ isOpen: true, data: item });
              },
              standout: false,
            },

            {
              _id: 2,
              name: "Delete",
              icon: "fa-regular fa-trash-can",
              standout: true,
              onClick: () => {
                setDeleteModal({
                  isOpen: true,
                  data: item,
                });
              },
            },
          ],
        },
      ],
    };
  });

  // add or edit Plans =================>
  function plansManageResponse(res) {
    if (res?.status === 200 || res?.status === 201) {
      if (res?.status === 201) {
        if (filters?.page === 1) {
          updateData((pre) => ({ ...pre, data: [res?.data, ...pre?.data] }));
          refetch();
        } else {
          setFilters((pre) => ({ ...pre, page: 1 }));
        }
      }
      if (res?.status === 200) {
        updateData((pre) => ({
          ...pre,
          data: pre?.data?.map((item) =>
            item?._id === res?.data?._id ? res?.data : item
          ),
        }));
      }
      setModalOpen({ isOpen: false, data: null });
    } else {
      toast.warning(res?.message);
    }
  }

  //   Plans delete handler =================>
  const { mutate: deleteHandler, isPending: deletePending } = useMutation({
    mutationFn: async (payload) => {
      const res = await planDelete({
        ids: Array.isArray(payload) ? payload : [payload],
      });
      return { res, payload: Array.isArray(payload) ? payload : [payload] };
    },
    onSuccess: ({ res, payload }) => {
      if (res?.status === 200) {
        setDeleteModal({ isOpen: false, data: null });
        updateData((pre) => {
          pre.data = (pre?.data || [])?.filter(
            (item) => !payload?.includes(item?._id)
          );
          return { ...pre };
        });
        if (data?.metadata?.totalDocs > filters?.limit) {
          refetch();
        }
      }
    },
    onError: (error) => {
      console.log(error);
    },
  });

  async function plansOrderingHandler(newData, oldData) {
    console.log({ newData, oldData });

    const ordering_data = newData?.map((item, i) => ({
      id: item?._id,
      ordering: i,
    }));
    const res = await planOrdering({ ordering_data });
    if (res?.status !== 200) {
      updateData((pre) => {
        pre.data = oldData;
        return { ...pre };
      });
    }
  }

  return (
    <div className="space-y-4 w-full flex flex-col pb-10">
      <div className="space-y-8">
        <div className="font-bold text-center text-lg xl:text-3xl text-chestnut-rose">
          Plans Management
        </div>
        <div className="flex items-center gap-3">
          <div className="w-36">
            <LimitSelect
              value={filters?.limit}
              allValue={data?.metadata?.totalDocs}
              onChange={(val) => handleFilterChange("limit", val, setFilters)}
            />
          </div>
          <div className="w-72">
            <Search
              placeholder={"Search here"}
              search={(val) => {
                setKeyword(val);
                handleFilterChange("page", 0, setFilters);
              }}
            />
          </div>
          <div className="relative">
            <Button
              buttonClasses={
                "!bg-transparent border border-transparent !h-10 hover:!bg-chestnut-rose/10 hover:!border-chestnut-rose/10"
              }
              buttonLabel={"Create New"}
              buttonLabelClasses={"font-medium !text-sm text-chestnut-rose"}
              buttonFunction={() => setModalOpen({ isOpen: true, data: null })}
            />
          </div>
        </div>
      </div>
      <Table
        tableHeadData={tableHeadData}
        tableData={tableData}
        isLoder={isLoading}
        pageCount={data?.metadata?.totalPages}
        currentPage={filters?.page}
        onPageChange={(val) => {
          handleFilterChange("page", val, setFilters);
          setSelectedItems([]);
        }}
        handleOrdering={(newData, oldData) => {
          plansOrderingHandler(newData, oldData);
        }}
        originalData={[...(data?.data || [])]}
        setOriginalData={(data) =>
          updateData((pre) => {
            pre.data = data;
            return { ...pre };
          })
        }
        isFetching={isFetching}
        isOrderingDisabled={false}
        selectedItems={selectedItems}
        setSelectedItems={setSelectedItems}
        tableActionDropdownContainer={"!w-48"}
      />
      <ManagePlanModal
        open={modalOpen?.isOpen}
        data={modalOpen?.data}
        close={() => setModalOpen({ isOpen: false, data: null })}
        getResponse={plansManageResponse}
      />
      <DeleteModal
        open={deleteModal?.isOpen}
        loading={deletePending}
        onClose={() => setDeleteModal((pre) => ({ data: null, isOpen: false }))}
        deleteHandler={() => {
          deleteHandler(deleteModal?.data?._id);
        }}
      />
    </div>
  );
};

export default Plans;
